import { render, staticRenderFns } from "./WBotsInstructions1.vue?vue&type=template&id=0d8f5526&"
import script from "./WBotsInstructions1.vue?vue&type=script&lang=js&"
export * from "./WBotsInstructions1.vue?vue&type=script&lang=js&"
import style0 from "./WBotsInstructions1.vue?vue&type=style&index=0&id=0d8f5526&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "general/lang/WBotsInstructions.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Freleases%2Ffront%2Ffront_131%2Fsrc%2Fgeneral%2Fcomponents%2FwidgetComponents%2FWBots%2FWBotsInstructions1.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports